import React, { useEffect } from 'react';
import { getThemeComponent } from '@/utils/themeImports';
import { specificThemeRender } from '@/utils/specificThemeRender';
import { useSSRSelector } from 'src/redux';
import ErrorMsg from './ErrorMsg';
import { ssrDataCall } from 'src/utils/ssrCommonApiCall';
import { useDispatch } from 'react-redux';
import {
  saveCatalogCategories,
  saveCatalogTags,
  saveCollections,
} from 'src/redux/actions';

const Error404 = () => {
  const dispatch = useDispatch();
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);

  useEffect(() => {
    ssrDataCall(['collections', 'categories', 'seo'], storeInfo).then((data: any) => {
      dispatch(saveCatalogCategories(data?.catalogCategories || []));
      dispatch(saveCollections(data?.collections || []));
      dispatch(saveCatalogTags(data?.catalogTags || []));
    });
  }, [storeInfo]);

  return (
    <div className="ErrorPage_wrapper">
      {specificThemeRender(storeInfo)?.components?.Header?.map((layout) => {
        return getThemeComponent(layout.sub_type, layout.name, layout);
      })}
      <ErrorMsg />
      <section className="EroorPage_body_wrapper">
        {specificThemeRender(storeInfo)?.components?.Footer?.map((layout) => {
          return getThemeComponent(layout.sub_type, layout.name, layout);
        })}
      </section>
    </div>
  );
};

export default Error404;
